import feathersClient, { makeServicePlugin, BaseModel } from '@/api-client'
class Region extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'Region'

  static instanceDefaults (data, { store, models }) {
    return {
      status: 'ACTIVE',
      type: 'ASP_REGION'
    }
  }
}
const servicePath = 'regions'
const servicePlugin = makeServicePlugin({
  Model: Region,
  whitelist: ['$eager', '$regex', '$iRegexp', '$options'],
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
